import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import {Field} from 'react-final-form';
import {connect} from 'react-redux';


function Text(props){
  const[err, setErr]=useState(undefined);

  let title=props.title;
  if(props.text_array!=undefined && props.text_array[props.title]!=undefined){title=props.text_array[props.title];}
  return(
    <Field name={props.name}>{(f)=>{
        if(err!=f.meta.error && f.meta.error!=''){setErr(f.meta.error);}
        return(<TextField InputProps={(props.currency==true)?{
            style:{fontSize:undefined},
            maxlength:props.maxlength,
            startAdornment: <InputAdornment position="start">{props.workspace.currency}</InputAdornment>,
          }:{style:{fontSize:undefined}}} InputLabelProps={{ style: { fontSize: undefined } }}  disabled={props.disabled} type={props.type} required={props.required} variant={(props.variant=='not_outlined')?undefined:(props.variant!=undefined)?props.variant:'outlined'} size='small' error={(props.error!=undefined)?props.error:(err!='' && err!=undefined)?true:false} helperText={(props.helperText!=undefined)?props.helperText:err} multiline={(props.rows==undefined)?false:true} rows={props.rows} label={title} value={processValue(props, (props.value!=undefined)?props.value:f.input.value)} onChange={(e)=>{let n=e.target.value; if(props.max!=undefined && props.max<n){n=props.max;}else if(props.min!=undefined && props.min>n){n=props.min;}; if(props.multiply_by!=undefined){n=n*props.multiply_by; if(n==0){n='';}} if(props.onChange!=undefined){props.onChange(n);}else{f.input.onChange(n);}}} style={{width:(props.width!=undefined)?props.width:'calc(100% - 20px)', maxWidth:props.maxWidth, marginLeft:'10px', marginTop:(props.marginTop!=undefined)?props.marginTop:'5px', marginBottom:(props.marginBottom!=undefined)?props.marginBottom:'5px', backgroundColor:(props.color=='transparent')?undefined:'#f7f9fc', fontSize:(props.fontSize!=undefined)?props.fontSize:undefined}}/>)}}</Field>
  )
}

function processValue(props, value){
  if(props.multiply_by!=undefined && value!=''){value=value/props.multiply_by;}
  return value;
}

export default connect(ss,dd)(Text);


function ss(state){
  return {
    text_array:state.account.text,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id]
  }
}

function dd(dispatch){
  return {
    getText:(info)=>{dispatch({type:'REQUEST_INDEX_ACCOUNT_TEXT'})},
  }
}
